<template>
  <div class="pro-rel-est">
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    
    <!-- LIBERA O CARREGAMENTO DA PAGINA -->
    <template v-else-if='statusGeral === ""'>
      <div class="app-fil-rel-nov">
        <table>
          <tr class="n-col-3">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_cat"
              :cpntNenhum="false"

              :cpntRouter="'/produto/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelEstAtualizarFiltro(value, 'pro_cat') }"
              ref="pro_cat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Marca Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_mar"
              :cpntNenhum="false"

              :cpntRouter="'/produto/marca/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelEstAtualizarFiltro(value, 'pro_mar') }"
              ref="pro_mar"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'codigo' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ]"
              :cpntNome="'Produto'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pro"
              :cpntNenhum="false"

              :cpntRouter="'/produto/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } }"
              :cpntWhere="() => { return proRelEstMontarWhereFiltro('pro') }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelEstAtualizarFiltro(value, 'pro') }"
              ref="pro"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table>
          <tr class="n-col-3">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'intervalo'"
              :cpntNome="'Intervalo de valores (de venda)'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.int"
              :cpntNenhum="false"

              @UPDATE_VALUE_FILTRO="(value) => { proRelEstAtualizarFiltro(value, 'int') }"
              ref="int"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'select'"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome' ]"
              :cpntNome="'Tipo de busca'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.bus"
              :cpntNenhum="false"

              :cpntOnBuscarOptions="proRelEstBuscarTipoDeBusca"
              @UPDATE_VALUE_FILTRO="(value) => { proRelEstAtualizarFiltro(value, 'bus') }"
              ref="bus"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'calendario'"
              :cpntNome="'Calcular estoque até:'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.dat"
              :cpntNenhum="false"

              @UPDATE_VALUE_FILTRO="(value) => { proRelEstAtualizarFiltro(value, 'dat') }"
              ref="dat"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>
      </div>

      <div class="pro-rel-est--botao">
        <App-Button :cpntStatus="pesquisa === 'carregando' ? pesquisa: ''" :cpntClass="'btn btn-primary'" @onClick="() => { proRelEstPesquisar() }">Pesquisar</App-Button>
      </div>

      <div class="pro-rel-est--resultado" v-if="router !== ''">
        <template v-if="filtros.bus !== 'com_estoque_desativado'"> 
          <div v-if="grafico !== null" class="pro-rel-est--grafico">
            <canvas ref="grafico" width="1000" height="300" style="position: relative; z-index: 0;"></canvas>
          </div>
  
          <div class="totais" v-if="totais !== null" title="Abaixo a soma dos valores de todas as páginas">
            <div style="text-align: right;">
              <App-Explica :cpntTitle='"Abaixo a soma dos valores de todas as páginas"'></App-Explica>
            </div>
  
            <div class="valores">
              <table>
                <tr>
                  <td>
                    Custo total em estoque:
                  </td>
                  <td>
                    Potencial de faturamento:
                  </td>
                  <td>
                    Lucro bruto com a venda total deste estoque:
                  </td>
                  <td>
                    Quantidade total em estoque atual é de:
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>R$ <span v-html="totais._custoTotal"></span></span>
                  </td>
                  <td>
                    <span>R$ <span v-html="totais._vendaTotal"></span></span>
                  </td>
                  <td :class="Number(totais.lucroTotal_v) > 0 ? 'lucro' : (Number(totais.lucroTotal_v) < 0 ? 'custo' : '')">
                    <span>R$ <span v-html="totais._lucroTotal"></span></span>
                  </td>
                  <td class="estoque" :class="Number(totais.estoque_total_v) > 0 ? 'lucro' : (Number(totais.estoque_total_v) < 0 ? 'custo' : '')">
                    <span><span v-html="totais.estoque_total"></span></span>
                  </td>
                </tr>
              </table>
  
              <!-- <div class="">
                Custo total em estoque:
                <br/>
                <span>R$ <span v-html="totais._custoTotal"></span></span>
              </div>
              <div class="">
                Potencial de faturamento:
                <br/>
                <span>R$ <span v-html="totais._vendaTotal"></span></span>
              </div>
              <div :class="Number(totais.lucroTotal) > 0 ? 'lucro' : (Number(totais.lucroTotal) < 0 ? 'custo' : '')">
                Lucro bruto com a venda total deste estoque:
                <br/>
                <span>R$ <span v-html="totais._lucroTotal"></span></span>
              </div>
              <div class="estoque" :class="Number(totais.estoque_total) > 0 ? 'lucro' : (Number(totais.estoque_total) < 0 ? 'custo' : '')">
                Quantidade total em estoque atual é de:
                <br/>
                <span><span v-html="totais.estoque_total"></span></span>
              </div> -->
            </div>
          </div>
        </template>

        <App-Tabela
        :cpntStatus="statusTabela"
        :cpntBotaoExportar="exportar"
        :cpntMostrarMper="true"
        :cpntApiTabPerFiltros="false"
        :cpntApiRouter="router"
        :cpntApiMethods="method"
        :cpntColuna="colunas"
        :cpntLinha="linhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntSetarValores="proRelEstSetarLinhas"
        :cpntApiBuscaComplementar="proRelEstSetarTotais"
        :cpntApiMontarQueryGet="proRelEstMontarQueryGet"
        ref="tabela">
        <!-- SETA A COLUNA NOME -->
        <template v-slot:col_nome="{ linha }">
          <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { proRelEstAbrirCadastro("produto", linha.id) }'>
            <span v-html="linha.nome"></span>
          </App-Button>
        </template>

        <!-- SETA O FORNECEDOR -->
        <template v-slot:col_fornecedor="{ linha }">
          <App-Button v-if="[ '', null, undefined, 0, '0' ].indexOf(linha.id_for) === -1" :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { proRelEstAbrirCadastro("contato", linha.id_for) }'>
            <!-- COLOCA O NOME DO CONTATO  -->
            <span v-html="linha.id_for_nome"></span>

            <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA  -->
            <span v-if='linha.id_for_pessoa === "j" && linha.id_for_empresa !== ""' v-html="' (' + linha.id_for_empresa + ')'"></span>

            <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO  -->
            <b v-if='linha.id_for_status !== "1"' v-html="'[Excluído]'"></b>
          </App-Button>
        </template>

        <template v-slot:col_lucro_bruto="{ linha }">
          <span v-html="linha._lucro_bruto_valor"></span>
          <template v-if="linha._lucro_bruto_valor !== '---'">
            <br/>
            <span v-html="linha._lucro_bruto_porcentagem + '%'"></span>
          </template>
        </template>

        <template v-slot:col__custo_total="{ linha }">
          <span v-html="linha._custo_total"></span>

          <!-- ({{ linha.est_calc }}) -->
          <App-Button v-if="linha.flagTotal !== true && linha.est_calc === '1'" :data-time="time" style="padding: 2px 3px;" :cpntIcone="'info'" title="Clique aqui para as informações do custo" @onClick="() => { detalheCusto = linha } " ref="btDialogRel"></App-Button>
        </template>

        <!-- SETA O BOTÃO HISTORICO -->
        <template v-slot:col_historico="{ linha }">
          <App-Button :cpntClass="[ 'btn', 'btn-info', 'btn-sm' ]" :cpntTexto="'Histórico'" @onClick='() => { proRelEstAbrirHistorico(linha) }'></App-Button>
        </template>
        </App-Tabela>
        <!-- </App-Tabela-2>  -->        
      </div>
    </template>

    <App-Relatorio-Detalhe-Custo v-if="detalheCusto !== null"
    :cpntSimulacao="true"
    :cpntDetalhe="detalheCusto._backup"
    :cpntFecharFormulario="() => { detalheCusto = null }"
    ></App-Relatorio-Detalhe-Custo>
  </div>
</template>

<style scoped>
.pro-rel-est--botao {
  margin-top: 10px;
  text-align: center;
}  
.pro-rel-est--resultado {
  margin-top: 10px;
}
  .pro-rel-est--resultado > .totais {
    max-width: 750px;
    margin: 0px auto;
    border: 1px solid #d5dee5;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 0px;
    margin-top: 15px;
    padding: 10px 0px;
    text-align: center;
    background-color: #f4f9fe;
    text-decoration: none;
    color: #333;
    vertical-align: top;
  }
  .pro-rel-est--resultado > .totais > .titulo {
    padding-bottom: 5px;
  }
    .pro-rel-est--resultado > .totais > .titulo svg {
      vertical-align: -3px;
    }

    .pro-rel-est--resultado > .totais > div > .cpnt-app-explica {
      margin-right: 5px;
      margin-top: -5px;
    }
  
  .pro-rel-est--resultado > .totais > .valores > table {
    width: 100%;
  }
    .pro-rel-est--resultado > .totais > .valores > table > tr > td {
      width: calc(100% / 4);
    }
    .pro-rel-est--resultado > .totais > .valores > table > tr:first-child > td {
      vertical-align: top;
    }
    .pro-rel-est--resultado > .totais > .valores > table > tr:last-child > td {
      vertical-align: bottom;
    }
    
      .pro-rel-est--resultado > .totais > .valores > table > tr > td > span {
        font-weight: bold;
      }
      .pro-rel-est--resultado > .totais > .valores > table > tr > td.custo > span {
        color: red;
      }
      .pro-rel-est--resultado > .totais > .valores > table > tr > td.venda > span {
        color: green;
      }
      .pro-rel-est--resultado > .totais > .valores > table > tr > td.lucro > span {
        color: blue;
      }

      .pro-rel-est--resultado > .pro-rel-est--grafico {
        max-width: 1000px !important;
        margin: 0px auto;
      }
</style>

<style>
.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col__custo_total {
  -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
  -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
  box-shadow: inset 0px 1px 0px 0px #ffffff;
  background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f7c6c6), color-stop(1, #ecc5bd) );
  background: -moz-linear-gradient( center top, #f7c6c6 5%, #ecc5bd 100% );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7c6c6', endColorstr='#ecc5bd');
  background-color: #f7c6c6;
  text-decoration: none;
}

.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col__venda_total {
  -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
  -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
  box-shadow: inset 0px 1px 0px 0px #ffffff;
  background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #cdfacd), color-stop(1, #bdecbd) );
  background: -moz-linear-gradient( center top, #cdfacd 5%, #bdecbd 100% );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#cdfacd', endColorstr='#bdecbd');
  background-color: #cdfacd;
  text-decoration: none;
}

.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col_lucro_bruto {
  background-color: #D4E7F1;
  background-image: -moz-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
  background-image: -webkit-gradient(linear, color-stop(0, #EDF5F9), color-stop(1, #D4E7F1));
  background-image: -webkit-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
  background-image: -o-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
  background-image: -ms-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
  background-image: linear-gradient(#EDF5F9 0, #D4E7F1 100%);
}

/* .pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col_custo_total {
  text-align: right;
}
.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col_custo_total > div > span > button {
  margin-left: 3px;
} */

.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col__custo_total,
.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col_lucro_bruto,
.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col__venda_total {
  width: 85px;
  text-align: right;
}
.pro-rel-est > .pro-rel-est--resultado > table > tbody > tr > td.col__custo_total > div > span > button {
  margin-left: 3px;
}
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        type: Object
      }
    },
    components: {
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'App-Relatorio-Detalhe-Custo': () => import('@/components/produto/relatorios/Relatorio-Detalhe-Custo.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        detalheCusto: null,
        statusTabela: '',
        filtros: {
          pro: '',
          pro_cat: '',
          pro_mar: '',
          int: '',
          bus: '',
          dat: ''
        },
        pesquisa: null,
        tabper: 'ProdutoRelEstoque',
        exportar: null,
        tabPerOrder: [],
        router: '',
        method: '',
        colunas: [],
        linhas: [],
        totais: null,
        grafico: null
      }
    },
    mounted: function () {
      this.proRelEstIniciar()
    },
    methods: {
      proRelEstMontarWhereFiltro: function (campo) {
        // INICIA A VARIAVEL WHERE
        var where = {} 
        
        // SETA O VALOR DE CADA CAMPO
        switch (campo) {
          case 'pro':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.pro_cat.join() })
            }

            // VERIFICA SE TEM QUE FILTRAR MARCA
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ f: 'id_mar', o: '=', v: this.filtros.pro_mar.join() })
            }
            break

          case 'ser':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.ser_cat.join() })
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return where
      },
      proRelEstAtualizarFiltro: function (value, chave) {
        // SETA O NOVO VALOR DO FILTRO
        this.filtros[chave] = value

        // VERIFICA A AÇÃO PERSONALIZADA QUE DEVE REALIZAR
        switch (chave) {
          case 'pro_cat':
          case 'pro_mar':
            this.filtros.pro = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proRelEstBuscarTipoDeBusca: function (callback) {
        // INICIA A VARIAVEL DE OPÇÕES
        var options = [
          { id: 'estoque_menor_ou_igual_a_zero',                      nome: 'Estoque menor ou igual a zero' },
          { id: 'estoque_maior_ou_igual_a_zero',                      nome: 'Estoque maior ou igual a zero' },
          { id: 'estoque_maior_que_zero',                             nome: 'Estoque maior que zero' },
          { id: 'com_estoque_desativado',                             nome: 'Com estoque desativado' },
          { id: 'com_estoque_ativado',                                nome: 'Com estoque ativado' },
          { id: 'quantidade_em_estoque_abaixo_da_quantidade_minima',  nome: 'Quantidade em estoque abaixo da quantidade mínima' }
        ]

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      proRelEstSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proRelEstSetarStatusTabela: function (status) {
        // SETA O STATUS DA TELA
        this.statusTabela = status
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proRelEstIniciar: function () {
        // SETA O STATUS DA TABELA
        this.proRelEstSetarStatusTabela('carregando')

        // SETA AS ORDENAÇÕES DISPONIVEIS
        this.tabPerOrder = [
          { id: '0',  nome: 'Código Ordem Decrescente',    chave: 'codigo_ordem_decrescente'         },
          { id: '1',  nome: 'Código Ordem Crescente',      chave: 'codigo_ordem_crescente'           },
          { id: '2',  nome: 'Ordem Alfabética',            chave: 'ordem_alfabetica'                 },
          { id: '3',  nome: 'Qtde estoque Decrescente',    chave: 'quantidade_estoque_descrescente'  },
          { id: '4',  nome: 'Qtde estoque Crescente',      chave: 'quantidade_estoque_crescente'     },
        ]

        // SETA O MAPA DE EXPORTAÇÃO
        this.exportar = {
          format: [ 'xlsx', 'pdf' ]
        }

        // SETA AS COLUNAS DA TABELA
        this.colunas = [
          { mPer: 2, chave: 'codigo',                 nome: 'Cód.'               },
          { mPer: 2, chave: 'nome',                   nome: 'Nome'               },
          { mPer: 1, chave: 'id_cat_nome',            nome: 'Categoria'          },
          { mPer: 1, chave: 'id_mar_nome',            nome: 'Marca'              },
          { mPer: 1, chave: 'fornecedor',             nome: 'Fornecedor'         },
          { mPer: 1, chave: 'id_uni',                 nome: 'Unidade'            },
          { mPer: 1, chave: '_qtde_min',              nome: 'Qtde. Mínima'       },
          { mPer: 1, chave: '_inicio',                nome: 'Qtde Ini.'          },
          { mPer: 1, chave: '_comprado',              nome: 'Comprados'          },
          { mPer: 1, chave: '_fabricado',             nome: 'Fabricados'         },
          { mPer: 1, chave: '_consumido',             nome: 'Consumido'          },
          { mPer: 1, chave: '_vendido',               nome: 'Vendidos'           },
          { mPer: 1, chave: '_dem_dev_fornecedor',    nome: 'Dev. Fornecedor'    },
          { mPer: 1, chave: '_dem_dev_cliente',       nome: 'Dev. Cliente'       },
          { mPer: 1, chave: '_estoque',               nome: 'Qtde. Estoque'      },
          { mPer: 0, chave: 'historico',              nome: 'Histórico'          },
          { mPer: 1, chave: '_valor_for',             nome: 'Val. For.'          },
          { mPer: 1, chave: '_custo_total',           nome: 'Custo Total'        },
          { mPer: 1, chave: '_valor_ven',             nome: 'Val. Ven.'          },
          { mPer: 1, chave: '_venda_total',           nome: 'Venda Total'        },
          { mPer: 1, chave: 'lucro_bruto',            nome: 'Lucro Bruto'        }
        ]

        // SETA OS FILTROS
        if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
          if ([ '', null, undefined ].indexOf(this.cpntFiltros.pro) === -1) {
            this.filtros.pro = this.cpntFiltros.pro.join().split(',')
          }
        }

        // SETA O STATUS DA PAGINA
        this.proRelEstSetarStatusGeral('')

        // VERIFICA SE DEVE REALIZAR O PESQUISAR OU NÃO
        if (this.$route.name === 'produto_relatorio_estoque_busca') {
          this.proRelEstPesquisar()
        }
        // // INICIA O CARREGAMENTO DOS DADOS
        // this.proRelEstPesquisar()
      },
      proRelEstMontarQueryGet: function (pag, rpp, exportar = null, success = null) {
        // VERIFICA SE DEVE AGUARDAR CARREGAMENTO
        if (success === null) {
          return new Promise((successP) => { this.proRelEstMontarQueryGet(pag, rpp, exportar, successP) })
        } else if (this.tabPerOrder.length === 0) {
          setTimeout(() => { this.proRelEstMontarQueryGet(pag, rpp, exportar, success) }, 50)
        // } else if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat.dataFim === undefined)) {
        //   setTimeout(() => { this.proRelEstMontarQueryGet(pag, rpp, exportar, success) }, 50)
        } else {
          // MONTA A PESQUISA QUE SERÁ FEITA
          var queryGet = {}
  
          // SETA O FILTRO PRODUTO CATEGORIA
          if (this.filtros.pro_cat !== '') {
            queryGet.categoria = JSON.stringify(this.filtros.pro_cat)
          }
  
          // SETA O FILTRO PRODUTO MARCA
          if (this.filtros.pro_mar !== '') {
            queryGet.marca = JSON.stringify(this.filtros.pro_mar)
          }
  
          // SETA O FILTRO PRODUTO
          if (this.filtros.pro !== '') {
            queryGet.produto = JSON.stringify(this.filtros.pro)
          }
  
          // SETA O FILTRO PRODUTO
          if (this.filtros.int !== '') {
            // SETA O VALOR INICIAL
            queryGet.valor_ven_de = this.filtros.int.ini
            if ([ '', null, undefined ].indexOf(queryGet.valor_ven_de) === -1 && isNaN(queryGet.valor_ven_de) === true) {
              // REMOVE O PONTO
              while (queryGet.valor_ven_de.indexOf('.') !== -1) {
                queryGet.valor_ven_de = queryGet.valor_ven_de.replace('.', '')
              }
  
              // CONVERTE A VIRGULA
              queryGet.valor_ven_de = queryGet.valor_ven_de.replace(',', '.')
            }
  
            // SETA O VALOR FINAL
            queryGet.valor_ven_ate = this.filtros.int.fim
            if ([ '', null, undefined ].indexOf(queryGet.valor_ven_ate) === -1 && isNaN(queryGet.valor_ven_ate) === true) {
              // REMOVE O PONTO
              while (queryGet.valor_ven_ate.indexOf('.') !== -1) {
                queryGet.valor_ven_ate = queryGet.valor_ven_ate.replace('.', '')
              }
  
              // CONVERTE A VIRGULA
              queryGet.valor_ven_ate = queryGet.valor_ven_ate.replace(',', '.')
            }
          }
  
          // SETA O FILTRO PRODUTO
          if (this.filtros.dat !== '') {
            queryGet.periodo_ate = this.filtros.dat
          }
  
          // SETA O FILTRO PRODUTO
          if (this.filtros.bus !== '') {
            queryGet.tipo = this.filtros.bus
          }

          // PEGA A PERSONALIZAÇÃO DA TABELA
          var tabper = this.$store.state.mPer[this.tabper]

          // VERIFICA SE TEM VALOR INICIAL
          tabper = ([ '', null, undefined ].indexOf(tabper) === -1 && [ '', null, undefined ].indexOf(tabper.order) === -1) ? tabper : { order: '0' }

          // VERIFICA SE TEM PERSONALIZAÇÃO
          queryGet.ordenacao = this.tabPerOrder.filter(item => item.id === tabper.order)[0].chave

          // SETA A PAGINAÇÃO
          if ([ '', null, undefined ].indexOf(exportar) === -1) {
            queryGet.exportar = { formato: exportar.tipo, pagina: exportar.pagina }
          } else {
            queryGet.paginacao = { pagina: pag, registros_por_pagina: rpp }
          }

          // RETORNA O QUERY MONTADO
          success(queryGet)
        }
      },
      proRelEstTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proRelEstTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proRelEstPesquisar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // LIMPA O VALOR DOS TOTAIS
        this.totais = null
        this.linhas = []

        // CHAMA A FUNÇÃO PARA DESTRUIR O GRAFICO
        this.proRelEstMontarGrafico()

        // SETA O NOME DA ROTA QUE DEVE CHAMAR
        this.router = '/produto/relatorio/estoque'
        
        // SETA O METHOD DA ROTA QUE DEVE USAR
        this.method = 'POST'

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
          this.proRelEstTabReiniciar()
        } else {
          this.proRelEstSetarStatusTabela('')
        }

        // // INICIA A QUERY
        // var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // // VERIFICA SE TEM QUE BUSCAR A QUANTIDADE
        // if (qtde === null) {
        //   // LIMPA O VETOR
        //   this.linha = []

        //   // INICIA A QUERY
        //   queryGet.limit.qty = 1

        //   // SETA OS FIELDS QUE DEVE RETORNAR
        //   queryGet.field = {}
  
        //   // MONTA O WHERE
        //   queryGet.where = this.proRelEstMontarWhere()
  
        //   // FAZ A BUSCA DOS DADOS NA API
        //   this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (retorno) => {
        //     this.proRelEstPesquisar(Number(retorno.countAll))
        //   }, this.proRelEstSetarStatusTabela)
        // } else {
        //   // INICIA A QUERY
        //   queryGet.limit.qty = 1000

        //   // SETA OS FIELDS QUE DEVE RETORNAR
        //   queryGet.field = { 
        //     id: null,
        //     codigo: null,
        //     nome: null,
        //     status: null,
        //     est_calc: null,
        //     qtde_min: null,
        //     valor_for_novo: { a: 'valor_for' },
        //     valor_ven_novo: { a: 'valor_ven' },
        //     id_ins_rec: { j: { nome: null } },
        //     id_for: { j: { nome: null, empresa: null, pessoa: null, status: null } },
        //     id_uni: null,
        //     id_cat: { j: { nome: null } },
        //     id_mar: { j: { nome: null } }
        //   }
  
        //   // MONTA O WHERE
        //   queryGet.where = this.proRelEstMontarWhere()

        //   // FAZ O CALCULO DO ESTOQUE DOS PRODUTOS
        //   queryGet.field_virtual = [ 'qtde_estoque' ]

        //   // INICIA A VARIAVEL
        //   var request = {}

        //   // MONTA O REQUEST A SER ENVIADO
        //   for (var i = 0; i <= qtde; (i = (i + 1000))) {
        //     // INICIA A CHAVE
        //     var chave = 'request__' + i

        //     // INICIA O VETOR
        //     request[chave] = {}
            
        //     // SETA O NOME DA ROTA QUE DEVE CHAMAR
        //     request[chave].rota = '/produto/get'

        //     // SETA O NOME DA ROTA QUE DEVE CHAMAR
        //     request[chave].metodo = 'POST'

        //     // SETA O QUERY GET
        //     request[chave].parametro = JSON.parse(JSON.stringify(queryGet))

        //     // SETA O VALOR INICIAL DO CAMPO
        //     request[chave].parametro.limit.row = JSON.parse(JSON.stringify(i))
        //   }

        //   // FAZ A BUSCA DOS DADOS NA API
        //   this.$store.state.comunicaAPI('/rota-multipla', 'POST', request, (retorno) => {
        //     // INICIA O VETOR
        //     var vetor = []

        //     // INICIA O VETOR DE RETORNO
        //     for (var index in retorno) {
        //       if (retorno[index].code === '200' && retorno[index].data.length >= 1) {
        //         vetor = vetor.concat(retorno[index].data)
        //       }
        //     }

        //     // CHAMA A FUNÇÃO PARA SETAR AS LINHAS RECEBIDAS
        //     this.proRelEstSetarLinhas(vetor)
        //   }, this.proRelEstSetarStatusTabela)
        // }
      },
      proRelEstMontarWhere: function () {
        // INICIA O WHERE
        var where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // SETA A BUSCA DO PRODUTO ESPECIFICADO
        if (this.filtros.pro !== '') {
          where.aAnd.push({ f: 'id_pro', o: 'in', v: this.filtros.pro.join() })
        }

        // SETA A BUSCA DO CATEGORIA DE PRODUTO ESPECIFICADO
        if (this.filtros.pro_cat !== '') {
          where.aAnd.push({ f: 'id_cat', o: 'in', v: this.filtros.pro_cat.join() })
        }

        // SETA A BUSCA DO MARCA DE PRODUTO ESPECIFICADO
        if (this.filtros.pro_mar !== '') {
          where.aAnd.push({ f: 'id_mar', o: 'in', v: this.filtros.pro_mar.join() })
        }

        // SETA A BUSCA DE INTERVALO DE VALORES
        if (this.filtros.int !== '') {
          // PEGA O VALOR INICIAL
          var valores = JSON.parse(JSON.stringify(this.filtros.int))

          // CONVERTE O VALOR INICIAL
          if (isNaN(valores.ini) === true) {
            // REMOVE A PONTO
            while (valores.ini.indexOf('.') > -1) {
              valores.ini = valores.ini.replace('.', '')
            }
            
            // ALTERA A PONTO PARA VIRGULA
            valores.ini = valores.ini.replace(',', '.')
          }

          // CONVERTE O VALOR FINAL
          if (isNaN(valores.fim) === true) {
            // REMOVE A PONTO
            while (valores.fim.indexOf('.') > -1) {
              valores.fim = valores.fim.replace('.', '')
            }
            
            // ALTERA A PONTO PARA VIRGULA
            valores.fim = valores.fim.replace(',', '.')
          }

          // SETA O WHERE RECEBIDO
          where.aAnd.push({ aAnd: [
            { f: 'valor_ven_novo', o: '>=', v: valores.ini },
            { f: 'valor_ven_novo', o: '<=', v: valores.fim }
          ] })
        }

        // RETORNA O WHERE MONTADO
        return where
      },
      proRelEstSetarTotais: function (linhas, callback, retorno) {
        // SETA OS VALORES TOTAIS RECEBIDOS
        this.totais = [ '', null, undefined ].indexOf(retorno.total) === -1 ? retorno.total : null

        // EXECUTA O CALLBACK SOLICITADO
        callback(linhas)
      },
      proRelEstSetarLinhas: function (vetor) {
        // SETA OS CAMPOS QUE DEVE FORMATAR PARA CADA VALOR
        var formatar = {
          qtde_min: 'VALOR_DECIMAL_FRONT',
          estoque_ajuste: 'VALOR_DECIMAL_FRONT',
          comprado: 'VALOR_DECIMAL_FRONT',
          dem_dev_cliente: 'VALOR_DECIMAL_FRONT',
          fabricado_na_fabricacao: 'VALOR_DECIMAL_FRONT',
          fabricado_na_venda: 'VALOR_DECIMAL_FRONT',
          fabricado: 'VALOR_DECIMAL_FRONT',
          consumido_na_fabricacao: 'VALOR_DECIMAL_FRONT',
          consumido_na_venda: 'VALOR_DECIMAL_FRONT',
          consumido: 'VALOR_DECIMAL_FRONT',
          vendido: 'VALOR_DECIMAL_FRONT',
          dem_dev_fornecedor: 'VALOR_DECIMAL_FRONT',
          estoque: 'VALOR_DECIMAL_FRONT',
          custo_total: 'VALOR_DECIMAL_FRONT',
          venda_total: 'VALOR_DECIMAL_FRONT',
          lucro_bruto_valor: 'VALOR_DECIMAL_FRONT',
          lucro_bruto_porcentagem: 'VALOR_DECIMAL_FRONT',
          valor_for: 'VALOR_DECIMAL_FRONT',
          valor_ven: 'VALOR_DECIMAL_FRONT',
        }

        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // SETA O BACKUP DA VARIAVEL
          vetor[index]._backup = JSON.parse(JSON.stringify(vetor[index]))

          // VERIFICA SE O CALCULO DE ESTOQUE TA ATIVADO
          if (vetor[index].est_calc !== '1') {
            vetor[index] = Object.assign(vetor[index], {
              qtde_min: '---',
              estoque_ajuste: '---',
              comprado: '---',
              dem_dev_cliente: '---',
              fabricado_na_fabricacao: '---',
              fabricado_na_venda: '---',
              fabricado: '---',
              consumido_na_fabricacao: '---',
              consumido_na_venda: '---',
              consumido: '---',
              vendido: '---',
              dem_dev_fornecedor: '---',
              estoque: '---',
              custo_total: '---',
              venda_total: '---',
              lucro_bruto_valor: '---',
              lucro_bruto_porcentagem: '---'
            })
          }

          // FORMATA OS VALORES RECEBIDOS
          for (var indexF in formatar) {
            vetor[index]['_' + indexF] = ([ '', null, undefined, '---' ].indexOf(vetor[index][indexF]) === -1) ? this.$store.state.FUN_MASCARA_VALOR(formatar[indexF], vetor[index][indexF]) : '---'
          }

          // SETA OS VALORES DOS CAMPOS, APÓS ALTERAÇÃO DE NOME DOS CAMPOS NA API
          if (vetor[index].estoque_ajuste !== undefined) {
            vetor[index].inicio = vetor[index].estoque_ajuste
            vetor[index]._inicio = vetor[index]._estoque_ajuste
          }

          // PINTA O CAMPO DO ESTOQUE EM VERMELHO SE ELE FOR MENOR OU IGUAL A ZERO
          if ([ '', null, undefined, '---' ].indexOf(vetor[index].estoque) === -1) {
            vetor[index]._estoque = '<span style="' + (Number(vetor[index].estoque) <= 0 ? 'color: red;': '') + ' font-size: var(--font-base-soma-14); font-weight: bold;">' + vetor[index]._estoque + '</span>'
          }
        }

        // SETA AS LINHAS NA TELA
        this.linhas = vetor

        // FORMATA OS VALORES RECEBIDOS
        for (var indexT in this.totais) {
          // REMOVE A FORMATAÇÃO DO CAMPO
          if (isNaN(this.totais[indexT]) === true) {
            // INICIA A CHAVE
            var chave = indexT + '_v'

            // COPIA O VALOR
            this.totais[chave] = this.totais[indexT]

            // REMOVE OS PONTOS DA STRING
            while (this.totais[chave].indexOf('.') > -1) {
              this.totais[chave] = this.totais[chave].replace('.', '')
            }

            // REMOVE OS PONTOS DA STRING
            while (this.totais[chave].indexOf(',') > -1) {
              this.totais[chave] = this.totais[chave].replace(',', '.')
            }

            // CONVERTE O NUMERO EM VALOR 
            this.totais[chave] = Number(this.totais[chave]).toString()
          }

          // SETA O VALOR FORMATADO NO CAMPO
          this.totais['_' + indexT] = ([ '', null, undefined, '---' ].indexOf(this.totais[indexT]) === -1) ? this.totais[indexT] : '0,00'
        }

        // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO NA TELA
        this.proRelEstMontarGrafico()

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TABELA
        this.proRelEstSetarStatusTabela('')
      },
      proRelEstAbrirHistorico: function (linha) {
        // SETA O FILTRO DO CAMPO
        var params = {}

        // SETA O FILTRO PRODUTO CATEGORIA
        if (this.filtros.pro_cat !== '') {
          params.pro_cat = this.filtros.pro_cat
        }
  
        // SETA O FILTRO PRODUTO MARCA
        if (this.filtros.pro_mar !== '') {
          params.pro_mar = this.filtros.pro_mar
        }
  
        // SETA O FILTRO PRODUTO
        params.pro = [ linha.id.toString() ]

        // SETA O FILTRO DE DATA
        if (this.filtros.dat !== '') {
          params.dat = { id: '99', dataIni: '01/01/1900', dataFim: this.filtros.dat }
        }
        
        // CARREGA OS PARAMETROS
        params = { name: 'produto_historico_busca', params: { cts: this.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify(params)) } }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      },
      proRelEstAbrirCadastro: function (tipo, id) {

        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: tipo, id: id }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.proRelEstPesquisar()
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      proRelEstMontarGrafico: function () {
        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }

        // LIMPA O VALOR DO GRAFICO
        this.grafico = null

        // VERIFICA SE TEM DADOS PARA MOSTRAR
        if ([ '', null, undefined ].indexOf(this.totais) === -1) {
          // LIMPA O VALOR DO GRAFICO
          this.grafico = ''
          // SETA OS TOTAIS DA PESQUISA
          // this.totais = {
          //   custo: '120.01',
          //   venda: '233.012',
          //   lucro: '112.402'
          // }

          // SETA AS BARRAS DO GRAFICO
          var colunas = [ 'Custo total em estoque', 'Potencial de faturamento', 'Lucro bruto com a venda total deste estoque' ]

          // // SETA AS LINHAS DO GRAFICO
          // var valores = [ 
          //   {
          //     label: 'Total Custo',
          //     data: [ Number(this.totais.custoTotal), Number(this.totais.custoTotal), 0 ],
          //     backgroundColor: '#b82e2e'
          //   },
          //   {
          //     label: 'Total Lucro',
          //     data: [ 0, Number(this.totais.lucroTotal), 0 ],
          //     backgroundColor: '#316395'
          //   },
          //   {
          //     label: 'Total Lucro',
          //     data: [ 0, 0, Number(this.totais.lucroTotal) ],
          //     backgroundColor: '#316395'
          //   },
          // ]

          // CALCULA O VALOR TOTAL
          var venda = Number((Number(this.totais.lucroTotal_v) + Number(this.totais.custoTotal_v)).toFixed(2))

          // SETA AS LINHAS DO GRAFICO
          var valores = [ 
            {
              label: '',
              data: [ Number(this.totais.custoTotal_v), 0, 0 ],
              backgroundColor: '#b82e2e'
            },
            {
              label: '',
              data: [ 0, venda, 0 ],
              backgroundColor: venda > 0 ? '#6bdf6b' : '#b82e2e'
            },
            {
              label: '',
              data: [ 0, 0, Number(this.totais.lucroTotal_v) ],
              backgroundColor: this.totais.lucroTotal_v > 0 ? '#316395' : '#b82e2e'
            }
          ]

          // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS
          this.proRelEstMontarGraficoTela(colunas, valores)
        }
      },
      proRelEstMontarGraficoTela: function (colunas, valores, tentativa = 0) {
        if (tentativa <= 10 && this.$refs.grafico === undefined) {
          setTimeout(() => { this.proRelEstMontarGraficoTela(colunas, valores, (tentativa + 1)) }, 500)
        } else if (this.$refs.grafico !== undefined) {
          // IMPORTA A FUNÇÃO
          const Chart = require('chart.js')
  
          // SETA O GRAFICO NA TELA
          this.grafico = new Chart(this.$refs.grafico, {
            type: 'bar',
            data: {
              labels: colunas,
              datasets: valores
            },
            options: {
              responsive: false,
              legend: {
                display: false
                // position: 'right' // place legend on the right side of chart
              },
              scales: {
                xAxes: [{
                  stacked: true // this should be set to make the bars stacked
                }],
                yAxes: [{
                  stacked: true,
                  ticks: {
                    callback: (label) => {
                      return this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', label.toString())
                    }
                  }
                }]
              },
              tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                  label: (item, item2) => {
                    return item2.datasets[item.datasetIndex].label + ': ' + 'R$ ' + this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', item.value)
                  }
                }
              }
            }
          //   {
          //   type: 'bar',
          //   data: {
          //     labels: Object.values(colunas),
          //     datasets: valores
          //   },
            // options: {
            //   scales: {
            //     xAxes: [
            //       {
            //         ticks: {
            //           autoSkip: false,
            //           maxRotation: 45,
            //           minRotation: 45,
            //         },
            //         scaleLabel: {
            //           display: true,
            //           labelString: 'Linha do tempo'
            //         }
            //       }
            //     ],
            //     // yAxes: [ 
            //     //   {
            //     //     scaleLabel: {
            //     //       display: true,
            //     //       labelString: (this.params.tipo === 'qtde' ? 'Quantidade' : 'Valor R$')
            //     //     },
            //     //     ticks: {
            //     //       callback: (label) => {
            //     //         switch (this.params.tipo) {
            //     //           case 'qtde':
            //     //             return this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', label.toString())

            //     //           case 'valor':
            //     //             return this.$store.state.FUN_MASK_VALOR('valorMoeda', (label * 100).toFixed(0).toString())
            //     //         }
            //     //       }
            //     //     }
            //     //   }
            //     // ]
            //   },
            //   // tooltips: {
            //   //   enabled: true,
            //   //   mode: 'single',
            //   //   callbacks: {
            //   //     label: (item) => {
            //   //       // INICIA A VARIAVEL
            //   //       var retorno = (this.params.tipo === 'qtde' ? 'Quantidade' : 'Valor') + ' ' + this.params.valores[item.datasetIndex].label + ': '
                    
            //   //       // VERIFICA O TIPO DE DADOS QUE ESTÁ TRABALHANDO
            //   //       switch (this.params.tipo) {
            //   //         case 'qtde':
            //   //           retorno += this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', item.value)
            //   //           break

            //   //         case 'valor':
            //   //           retorno += 'R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())
            //   //           break
            //   //       }

            //   //       // RETORNA O VALOR MONTADO
            //   //       return retorno
            //   //     }
            //   //   }
            //   // }
            // }
          })
        }
      },
    }
  }
</script>
